import isJsonString from './checkJsonString'
export default function getStatusCode(str) {
  const formatMessage = str.replaceAll("'", '"')
  return isJsonString(formatMessage) && JSON.parse(formatMessage).status_code
}
